<script setup lang="ts">
  import { computed, ref, watch, defineProps, defineEmits, nextTick  } from 'vue';
  import { useI18n } from '@/hooks/web/useI18n';
  import { COMMON_OPTIONS } from '@/utils/options'
  
  const { t } = useI18n()
  const props = defineProps({
    modelValue: { type:Array }
  })
  const _value = ref<any>([])
  const onChange = (item)=>{
    _value.value = item.colors
    emit('update:modelValue', _value.value)
  }

  const emit = defineEmits(['update:modelValue']);
  watch(()=>props.modelValue, (val:any) => {
    try{
      if(val){
        _value.value = [...val]
      }
    }catch(error){}
  }, 
  {
    immediate: true,
    deep: true
  })

</script>

<template>
  <div>
    <el-popover
      placement="bottom" trigger="click" :width="200"
      popper-class="colors-sel-popper">
      <template #reference>
        <div class="colors-sel">
          <div class="colors-sel-itm">
            <div v-for="(color,index1) in _value" :key="index1" :style="{backgroundColor:color}" >
            </div>
          </div>
        </div>
      </template>
      <div>
        <div
          v-for="(item,index) in COMMON_OPTIONS.colorSeries" :key="index"
          @click="onChange(item)" class="colors-sel-itm my-[5px]" >
          <div 
          v-for="(color,index1) in item.colors" :key="index1" 
          :style="{backgroundColor:color}">
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<style lang="less">
.colors-sel-itm{
  cursor: pointer;
  display: flex;
  align-items: center;
  &>div{
    width: 16px;
    min-height: 16px;
  }   
}
</style>
<style lang="less" scoped>
.colors-sel{
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--bdr-subtle-0_neutral-normal, #C8C8C8);
  background: var(--bg-subtlest-0_neutral-normal, #FFF);
}
</style>